import { createElementBlock as o, openBlock as n, createElementVNode as t } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return n(), o("svg", r, e[0] || (e[0] = [
    t("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.333 5.01c1.39-.224 2.796-.34 4.205-.346.121 0 .238.044.329.125.085.084.133.2.133.32v14a.453.453 0 0 1-.444.444C14.186 19.66 12 21.997 12 21.997m0 0V7.091m0 14.906s-2.187-2.337-9.556-2.444A.453.453 0 0 1 2 19.109v-14c0-.12.048-.236.133-.32a.5.5 0 0 1 .33-.125C9.822 4.762 12 7.091 12 7.091m0 0a5.5 5.5 0 0 1 1.458-3.05 6.9 6.9 0 0 1 3.235-2.017.53.53 0 0 1 .436.053.41.41 0 0 1 .204.356V16.31a7.27 7.27 0 0 0-3.875 2.186A5.33 5.33 0 0 0 12 21.562"
    }, null, -1)
  ]));
}
const c = { render: l };
export {
  c as default,
  l as render
};
